import { fetch } from 'http-common';

import { ProductCount, ProductData } from 'types/api/notification.type';

class NotificationDataService {
  private http = fetch();

  private ep = '/v1/notification';

  public async getAll(season: string, seasonLine: string) {
    return this.http.get(`${this.ep}/${season}/${seasonLine}/published`);
  }

  public async get(id: string) {
    return this.http.get(`${this.ep}/${id}`);
  }

  public async getProductCount(data: ProductCount[]) {
    return this.http.post(`${this.ep}/products/count`, { products: data });
  }

  public async getProductNotifications(data: ProductData) {
    return this.http.get(`${this.ep}/allNotificationFields`, {
      params: data,
    });
  }
}

const notificationDataService = new NotificationDataService();

export { notificationDataService };
